/**
 * GLOBAL TOKEN WAR — entry point.
 * `?tune=1` mounts the economy tuning harness (spec §7.8). `?play=US|EU|CN` skips the front
 * door (development shortcut). Otherwise the full app: BOOT → MENU → … → PLAY.
 */
export {};

const app = document.getElementById("app");
if (!app) throw new Error("#app missing");

const q = new URLSearchParams(location.search);
if (q.has("tune")) {
  const { mountHarness } = await import("./tune/harness");
  await mountHarness(app);
} else {
  const { mountApp } = await import("./screens/app");
  const play = q.get("play");
  await mountApp(app, play === "US" || play === "EU" || play === "CN" ? { playAs: play } : {});
}
